<template>
  <HeroSection bg-src="/images/audi-wheel.webp" title="Classes and prices" />

  <ContentCarClasses detailed-prices />

  <section>
    <div class="container py-6 text-center">
      <UButton variant="link" to="/files/DriveczechPricelist.pdf" external leading-icon="i-heroicons-document" class="mt-4">
        Download our full pricelist in PDF
      </UButton>
    </div>
  </section>

  <ContentPamentMethodsSection />

  <Footer />
</template>
